<template>
    <v-select v-model="query.sort" :items="sortItems" :class="`human-resource-sort-${className}`" :menuProps="{ attach: `.human-resource-sort-${className}` }" v-bind="attrs_input" @change="emit" />
</template>

<script>
import { attrs_input } from "@/assets/variables";

const initQuery = (query = {}) => ({
    ...query,

    ["sort"]: decodeURI(query["sort"] || "") || null,
});

const sortItems = [
    { value: null, text: "지원일 ↓" },
    { value: JSON.stringify({ appliedAt: 1 }), text: "지원일 ↑" },
    { value: JSON.stringify({ "resume.personalInformation.bornAt": -1, appliedAt: -1 }), text: "나이 ↑" },
    { value: JSON.stringify({ "resume.personalInformation.bornAt": 1, appliedAt: -1 }), text: "나이 ↓" },
    { value: JSON.stringify({ "resume.workExperience.span.years": -1, "resume.workExperience.span.months": -1, appliedAt: -1 }), text: "경력 ↓" },
    { value: JSON.stringify({ "resume.workExperience.span.years": 1, "resume.workExperience.span.months": 1, appliedAt: -1 }), text: "경력 ↑" },
];

export default {
    data: () => ({
        query: initQuery(),

        sortItems,
        attrs_input,
        className: Math.random().toString().slice(2),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },

    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            const { ...query } = this.query;

            if (!query["sort"]) delete query["sort"];

            delete query["page"];

            this.$router.push({ query });
        },
    },
};
</script>

